import buttonBase from './_buttonBase';
export default {
  extends: buttonBase,
  methods: {
    performAction: function performAction() {
      if (this.$_checkForprivacyOptOut(this.button) == true) {
        return;
      } // show the email modal


      var settings = {
        templateId: this.button ? this.button.templateId : '',
        dialogHeading: this.button ? this.button.dialogHeading : '',
        emailCode: this.button ? this.button.emailCode : '',
        dialogSettings: this.button ? this.button.dialogSettings : '',
        recaptchaKey: this.recaptchaPublicKey || '',
        analyticsEventParams: {
          EventType: 'Email',
          Position: this.$_getAnalyticsPosition() || ''
        },
        pageAttributes: this.pageAttributes || {}
      };
      this.$emit('set-modal', 'emailModal', settings);
      return true;
    }
  }
};